import { StepConfigSettingsRequestValuesByArchetype } from '@/components/stepConfigs/stepConfigSettingsForms';
import {
    AutomationTypesWithSettings,
    BetaTestingStyle,
    ChecklistItemPlacement,
    ChecklistItemReleaseTypes,
    ChecklistItemType,
    CompletedStepsTrigger,
    ReleaseStepType,
    RunwayModelsResponse,
    RelativeTimeTrigger,
    UserGroupId,
    RegressionTestingStrategy,
} from '@/types';
import { StepConfig } from '@/types/stepConfig';
import { Nullable } from '@/typescriptHelpers';

export enum StepConfigUpdatable {
    // Beta testing
    UpdateBetaTestingStyle = 'UPDATE_BETA_TESTING_STYLE',

    // Regression testing
    UpdateRegressionTestingStrategy = 'UPDATE_REGRESSION_TESTING_STRATEGY',

    // Checklist items
    CreateChecklistItemTemplate = 'CREATE_CHECKLIST_ITEM_TEMPLATE',
    UpdateChecklistItemTemplate = 'UPDATE_CHECKLIST_ITEM_TEMPLATE',
    DeleteChecklistItemTemplate = 'DELETE_CHECKLIST_ITEM_TEMPLATE',
    UpdateChecklistItemTemplateOrder = 'UPDATE_CHECKLIST_ITEM_TEMPLATE_ORDER',

    // General config
    UpdateStepConfig = 'UPDATE_STEP_CONFIG',
}

export interface UpdateBetaTestingStyleRequest {
    betaTestingStyle: BetaTestingStyle;
    prescribedBetaSoakDurationSeconds?: number;
}

export interface UpdateRegressionTestingStrategyRequest {
    appId: string;
    orgId: string;
    regressionTestingStrategy: RegressionTestingStrategy;
}

export interface CreateChecklistItemTemplateRequest {
    title: string;
    notifyEnabled: boolean;
    type: ChecklistItemType;
    placement: ChecklistItemPlacement;
    description?: string;
    approverGroups: UserGroupId[];
    owners: string[];
    releaseTypes: ChecklistItemReleaseTypes;
    targetCompletion?: RelativeTimeTrigger;
    incompleteReminderEnabled: boolean;
    autocompleteAtTargetCompletionEnabled: boolean;
    includeDescriptionInNotificationsEnabled: boolean;
    disableReminderAfterReleaseComplete: boolean;
    channels?: string[];
    originWorkflowRunId: Nullable<string>;
    originStepRunId: Nullable<string>;
}

export type UpdateChecklistItemTemplateRequest = CreateChecklistItemTemplateRequest;

export type DeleteChecklistItemTemplateRequest = void;

export interface UpdateChecklistItemTemplateOrderRequest {
    orderedItemIds: string[];
    originStepRunId: Nullable<string>;
}

export interface UpdateStepConfigRequest {
    originStepRunId?: string;
    integrationInstallationIds?: string[];
    integrationSpecificSettings?: StepConfigSettingsRequestValuesByArchetype<ReleaseStepType>;
    stepConfigGeneralSettings?: Pick<StepConfig, 'name'>;
    stepConfigArchetypeSpecificSettings?: StepConfigSettingsRequestValuesByArchetype<ReleaseStepType>;
}

export interface PingPendingChecklistItemsRequest {}

export interface UpdateAutomationSettingsRequest {
    enabled: boolean;
    data?: AutomationTypesWithSettings['data'];
    relativeTimeTrigger: RelativeTimeTrigger;
    completedStepsTrigger: CompletedStepsTrigger;
}

export const UPDATE_STEP_CONFIGS = 'UPDATE_STEP_CONFIGS';

export interface TryUpdateStepConfigsAction {
    type: typeof UPDATE_STEP_CONFIGS;
    payload: RunwayModelsResponse['stepConfigs'];
}

export const updateStepConfigs = (payload: RunwayModelsResponse['stepConfigs']): TryUpdateStepConfigsAction => {
    return {
        type: UPDATE_STEP_CONFIGS,
        payload: payload,
    };
};
